import {
	KeyboardEvent,
	ReactElement,
	useMemo
} from "react";
import { ActionListCheckbox } from "../ActionList/ActionListCheckbox";
import { Checkbox } from "../Checkbox/Checkbox";
import { ItemResponsiveBehavior } from "../CollapsibleList/CollapsibleList";
import { ToolbarPriority } from "./Toolbar";
import { ToolbarItem } from "./ToolbarItem";

export type ToolbarCheckboxProps = {
	value: boolean;
	onChange(value: boolean): void;
	trackingId?: string;
	isDisabled?: boolean;
	text: string;
	title?: string;
	responsiveBehavior?: ItemResponsiveBehavior;
};

export const ToolbarCheckbox = (props: ToolbarCheckboxProps): ReactElement => {
	const {
		value,
		onChange,
		text,
		title,
		isDisabled,
		trackingId,
		responsiveBehavior
	} = props;

	const priority = useMemo(
		(): number => {
			if (responsiveBehavior === "hide") {
				return ToolbarPriority.LowPriorityItem;
			}

			return ToolbarPriority.Default;
		},
		[responsiveBehavior]
	);

	return (
		<ToolbarItem
			priority={priority}
			responsiveBehavior={responsiveBehavior}
			isDisabled={isDisabled}
			renderNormalMode={(
				ref: (element: HTMLElement | null) => void,
				onKeyDown: (args: KeyboardEvent<HTMLElement>) => void,
				tabIndex: number
			) => (
				<Checkbox
					ref={ref}
					onKeyDown={onKeyDown}
					tabIndex={tabIndex}
					value={value}
					onChange={onChange}
					text={text}
					title={title}
					trackingId={trackingId}
					isDisabled={isDisabled}
				/>
			)}
			renderCollapsedMode={() => (
				<ActionListCheckbox
					value={value}
					onChange={onChange}
					text={text}
					isDisabled={isDisabled}
					trackingId={trackingId}
					shouldNotAutoCloseContainingDropOver
				/>
			)}
		/>
	);
};
ToolbarCheckbox.displayName = "Toolbar.Checkbox";